import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import swal from 'sweetalert'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import { appAllGetHelpDesk, appUpdateHelpDesk, appDeleteHelpDesk } from '../../store/helpdesk'
import PostPreview from '../../components/PostPreview/PostPreview'
import { toCamelCase } from '../../utils/Function'

function TableFilter() {
	const dispatch = useDispatch()
	const [page, setPage] = useState(1)
	const [showUserModal, setShowUserModal] = useState(false)
	const [rejectedId, setRejectedId] = useState(null)
	const [rejectionReason, setRejectionReason] = useState('')
	const [rejectionError, setRejectionError] = useState('')
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	const helpdesk = useSelector(state => state.helpdeskReducer.helpDesk)
	const paginate = useSelector(state => state.helpdeskReducer.paginate)
	const isloder = useSelector(state => state.helpdeskReducer.isloder)
	const isdeleted = useSelector(state => state.helpdeskReducer.isdeleted)

	useEffect(() => {
		dispatch(appAllGetHelpDesk({ page, limit: 10, sanstha: sansthaId || permissionOfSanstha }))
	}, [page, isdeleted, dispatch])

	const handleDeleteHelpDesk = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this help desk request?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(appDeleteHelpDesk(id)).then(() => {
					dispatch(
						appAllGetHelpDesk({ page, limit: 10, sanstha: sansthaId || permissionOfSanstha }),
					)
				})
			}
		})
	}

	const handleAcceptedHelpDeskBooking = id => {
		swal({
			title: 'Are you sure?',
			text: 'This issue has been resolved?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willAccept => {
			if (willAccept) {
				dispatch(appUpdateHelpDesk({ id, status: 'Accepted' })).then(() => {
					dispatch(
						appAllGetHelpDesk({ page: 1, limit: 10, sanstha: sansthaId || permissionOfSanstha }),
					)
				})
			}
		})
	}

	const handleRejectedHelpDeskBooking = id => {
		setRejectedId(id)
		setShowUserModal(true)
	}
	const hnadleSubmitRected = () => {
		if (!rejectionReason.trim()) {
			setRejectionError('Reason is required.')
			return
		}
		setRejectionError('')
		dispatch(
			appUpdateHelpDesk({
				id: rejectedId,
				rejectionreason: rejectionReason,
				status: 'Rejected',
			}),
		).then(() => {
			dispatch(appAllGetHelpDesk({ page: 1, limit: 10, sanstha: sansthaId || permissionOfSanstha }))
		})
		setShowUserModal(false)
		setRejectionReason('')
		setRejectedId(null)
	}
	const handleCloseModal = () => {
		setShowUserModal(false)
		setRejectionReason('')
		setRejectionError('')
		setRejectedId(null)
	}

	return (
		<>
			{/* {isloder && <PageLoader />} */}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="table-responsive bootgrid">
						<table className="table table-hover">
							<thead>
								<tr>
									<th>User</th>
									<th>Community</th>
									<th>Sanstha</th>
									<th>Description</th>
									<th>Status</th>
									<th>Resolve Date</th>
									<th>Action</th>
								</tr>
							</thead>

							{helpdesk?.data?.map(item => (
								<tbody key={item._id}>
									<tr>
										<td
											style={{
												maxWidth: '200px',
												wordWrap: 'break-word',
												whiteSpace: 'normal',
											}}
										>
											<PostPreview value={item?.userId?.profilePic || '/img/user.jpg'} />
											{item?.userId?.firstName} {item?.userId?.lastName}
											<br />
											{item?.user?.mobile}
										</td>
										<td
											style={{
												maxWidth: '150px',
												wordWrap: 'break-word',
												whiteSpace: 'normal',
												textTransform: 'capitalize',
											}}
										>
											{item?.hub ? (
												<>
													<PostPreview value={item?.hub?.image} />

													{toCamelCase(item?.hub?.name) || '—'}
												</>
											) : (
												''
											)}
										</td>
										<td
											style={{
												maxWidth: '150px',
												wordWrap: 'break-word',
												whiteSpace: 'normal',
												textTransform: 'capitalize',
											}}
										>
											{item?.sansthaId ? (
												<>
													{item.sansthaId.image && <PostPreview value={item?.sansthaId?.image} />}
													<br />
													{toCamelCase(item?.sansthaId?.name) || '—'}
												</>
											) : (
												''
											)}
										</td>
										<td>{item?.description}</td>
										<td>
											{item?.status === 'Pending' && (
												<span className="badge badge-primary">Pending</span>
											)}
											{item?.status === 'Accepted' && (
												<span className="badge badge-success">Resolved</span>
											)}
											{item?.status === 'Rejected' && (
												<span className="badge badge-success">Resolved</span>
											)}
										</td>
										<td>
											{item.resolveDate &&
												new Date(item.resolveDate).toLocaleDateString('en-US', {
													year: 'numeric',
													month: 'short',
													day: 'numeric',
												})}
										</td>
										{/* <td>
											{item.status === 'Pending' && (
												<div style={{ display: 'flex', gap: '5px' }}>
													<button
														type="button"
														className="btn btn-sm btn-green command-delete"
														onClick={() => handleAcceptedHelpDeskBooking(item?._id)}
													>
														<i className="fa fa-check" aria-hidden="true">
															{' '}
															Accept
														</i>
													</button>
													<button
														type="button"
														className="btn btn-sm btn-danger command-delete"
														onClick={() => handleRejectedHelpDeskBooking(item?._id)}
													>
														<i className="fa fa-ban" aria-hidden="true">
															{' '}
															Reject
														</i>
													</button>
												</div>
											)}
											{item.status === 'Rejected' && (
												<button
													type="button"
													className="btn btn-sm btn-danger command-delete"
													onClick={() => handleDeleteHelpDesk(item?._id)}
												>
													<em className="fa fa-trash fa-fw"></em>
												</button>
											)}
										</td> */}

										<td>
											{item.status === 'Pending' ? (
												<button
													type="button"
													className="btn btn-sm btn-success ml-1 mr-1"
													onClick={() => handleRejectedHelpDeskBooking(item?._id)}
												>
													<i className="fa fa-check" aria-hidden="true"></i> Resolve
												</button>
											) : (
												<button
													type="button"
													className="btn btn-sm btn-danger"
													onClick={() => handleDeleteHelpDesk(item?._id)}
												>
													<em className="fa fa-trash fa-fw"></em>
												</button>
											)}
										</td>
									</tr>
								</tbody>
							))}
						</table>
					</div>

					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>
			{showUserModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						top: '50px',
					}}
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title"> Rejection </h5>
								<button type="button" className="close" onClick={handleCloseModal}>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="form-group">
									<label>Reason of rejection</label>
									<textarea
										className="form-control"
										name="description"
										value={rejectionReason}
										onChange={e => setRejectionReason(e.target.value)}
										rows="3"
									/>
									{rejectionError && (
										<div style={{ color: 'red', marginTop: '5px' }}>{rejectionError}</div>
									)}
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
									Cancel
								</button>
								<button type="button" className="btn btn-primary" onClick={hnadleSubmitRected}>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default TableFilter
